<div class="mx-auto px-4">
  <div class="overflow-x-auto">
    <div class="mb-4">
      <p class="titre1 mt-4">{{ 'DIFFUSION.TITLE' |
        translate }}
        <mat-icon
        class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">video_library</mat-icon>
      </p>
    </div>
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }
    @if (!isLoading) {
      <div class="flex items-end justify-end mb-4">
        <div class="flex flex-col items-end gap-3">
          <div class="flex items-center gap-3">
            @if (!estRootLectureSeule) {
              <button (click)="ouvrirDialogAjout()"
                class="btn-primary-novo flex items-center gap-2">
                <mat-icon>add</mat-icon>
                {{ 'DIFFUSION.ADD' | translate }}
              </button>
            }
            @if (!estRootLectureSeule) {
              <button (click)="ouvrirDialogAjoutMultiple()"
                class="btn-primary-novo flex items-center gap-2">
                <mat-icon>add</mat-icon>
                {{ 'DIFFUSION.ADD_MULTIPLE' | translate }}
              </button>
            }
          </div>
          <div class="flex items-center gap-3">
            <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
              placeholder="{{ 'DIFFUSION.SEARCH' | translate }}..."
              class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
              <button mat-icon-button (click)="resetFilters()"
                class="h-8 w-8 bg-white-200 text-white-600 rounded">
                <mat-icon>restore</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="w-full overflow-x-auto">
          <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo"
            (matSortChange)="sortDataChange($event)">
            <ng-container matColumnDef="urlPlayer">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell text-left px-4 py-2">
                {{ 'DIFFUSION.URL_PLAYER' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell text-left px-4 py-2 border-b">
                <div class="flex items-center gap-2 max-w-fit">
                  <span class="truncate">{{ element.urlPlayer }}</span>
                  <button mat-icon-button (click)="copierUrl(element.urlPlayer)"
                    class="text-blue-600 hover:text-blue-800 flex-shrink-0"
                    [matTooltip]="'DIFFUSION.COPY_URL' | translate">
                    <mat-icon class="text-sm">content_copy</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="packageNom">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell text-left px-4 py-2">
                {{ 'DIFFUSION.PACKAGE_NAME' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell text-left px-4 py-2 border-b">
                @if (element.estMultiple) {
                  <div class="flex items-center gap-2">
                    <span>{{ element.titre }}</span>
                    <button mat-icon-button (click)="ouvrirPopupPaquets(element)"
                      [matTooltip]="'DIFFUSION.VIEW_PACKAGES' | translate"
                      class="text-gray-600 hover:text-gray-800 h-8 w-8 leading-8">
                      <mat-icon class="text-sm">visibility</mat-icon>
                    </button>
                  </div>
                } @else {
                  {{ getPackageNom(element) }}
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="langue">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell text-left px-4 py-2">
                {{ 'DIFFUSION.LANGUAGE' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell text-left px-4 py-2 border-b">
                {{ getLangueLabel(element.langue) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dureeVideo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell text-left px-4 py-2">
                {{ 'DIFFUSION.DURATION' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell text-left px-4 py-2 border-b">
                {{ formatDureeVideo(element.dureeVideo) }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dateCreation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell text-right px-4 py-2">
                {{ 'DIFFUSION.DATE_CREATION' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell text-right px-4 py-2 border-b">
                {{ element.dateCreation | dateFormat }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'DIFFUSION.ACTIONS' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="w-1/20 px-2 py-1 text-right">
                @if (!estRootLectureSeule) {
                  <button (click)="onModifierDiffusion(element)" mat-icon-button
                    class="text-blue-600 hover:text-blue-800"
                    [attr.aria-label]="'DIFFUSION.EDIT' | translate">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                @if (!estRootLectureSeule) {
                  <button (click)="supprimerDiffusion(element)" mat-icon-button
                    class="text-red-600 hover:text-red-800"
                    [attr.aria-label]="'DIFFUSION.DELETE' | translate">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
          </table>
          @if (dataSource.filteredData.length === 0) {
            <div class="text-center mt-2 text-gray-500">
              {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
            </div>
          }
          <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
            (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
      }
    </div>
  </div>